import { useState } from 'react'

/**
 * Before/after slider.
 *
 * The comparison is the substance of the proof, two thumbnails side by side
 * make people squint, one image wiped over the other makes the difference
 * obvious. A real range input sits on top so it also works by keyboard.
 */
export function PhotoCompare({
  beforeId,
  afterId,
  alt = 'Vorher-Nachher-Vergleich',
}: {
  beforeId: string
  afterId: string
  alt?: string
}) {
  const [position, setPosition] = useState(50)

  return (
    <figure className="compare" style={{ margin: 0 }}>
      <div className="compare-stage">
        <img className="compare-img" src={`/api/photos/${afterId}`} alt={alt} draggable={false} />
        <div className="compare-clip" style={{ width: `${position}%` }}>
          {/* Fixed to the stage width so the two images stay in register while clipped. */}
          <img className="compare-img" src={`/api/photos/${beforeId}`} alt="" draggable={false} />
        </div>

        <span className="compare-tag left">vorher</span>
        <span className="compare-tag right">nachher</span>

        <div className="compare-handle" style={{ left: `${position}%` }} aria-hidden="true">
          <span>⟺</span>
        </div>

        <input
          className="compare-range"
          type="range"
          min={0}
          max={100}
          step={1}
          value={position}
          onChange={(event) => setPosition(Number(event.target.value))}
          aria-label="Vergleich zwischen Vorher- und Nachher-Foto verschieben"
        />
      </div>
      <figcaption className="muted small" style={{ marginTop: 6 }}>
        Regler ziehen, um vorher und nachher zu vergleichen.
      </figcaption>
    </figure>
  )
}
